import { FileRoutesByFullPath } from '@providers';
import { UseNavigateResult } from '@tanstack/react-router';
import { DataTableSortStatus } from 'mantine-datatable';
import { getParamName } from '../../../../../../common';
import { getValidSortKey } from '../manageSorting';

type OnSortStatusChangeOptionsType = {
  newSortStatus: DataTableSortStatus;
  accessorOptions: string[];
  defaultAccessor: string;
  navigateFn: UseNavigateResult<keyof FileRoutesByFullPath>;
  tableId?: string;
};

export const onSortStatusChange = ({
  newSortStatus,
  accessorOptions,
  defaultAccessor,
  navigateFn,
  tableId,
}: OnSortStatusChangeOptionsType): void => {
  const sortKey = getValidSortKey({
    accessorOptions,
    accessor: newSortStatus.columnAccessor,
    defaultAccessor,
  });

  const sortValue = `${String(sortKey)}:${newSortStatus.direction}`;

  navigateFn({
    search: (currentSearch) => ({
      ...currentSearch,
      [getParamName('sort', tableId)]: sortValue,
    }),
  });
};
